import * as actionTypes from '../../../actions/actionType';

const deleteReviewReducer = (state = { }, action = {}) => {
  switch (action.type) {
    case actionTypes.DELETE_PRODUCT_REVIEW:
      return {
        ...state,
        loading: true,
        error: null
      };
    case actionTypes.DELETE_PRODUCT_REVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    case actionTypes.DELETE_PRODUCT_REVIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default deleteReviewReducer;
